<template>
  <div>
    <div class="ceiling">
       <home-top></home-top>
      <navicat :current="4" background="#fff"></navicat>
    </div>
    <!-- 头部占位 -->
    <!-- <div class="h-top"></div> -->
    <!-- banner图 -->
    <div class="bannre-box">
      <el-carousel height="400px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img class="banner-image" :src="item.image" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="content" v-loading="loading">
      <div class="content-inner w-1400">
        <div class="content-inner-left">
          <div class="article-top">
            <div class="article-title">{{ article.title }}</div>
            <div class="article-desc">
              <div class="desc-tag">
                <span class="tag-author">{{ article.author }}</span>
                <span class="tag" v-if="article.cate">{{
                  article.cate.cate_name
                }}</span>
              </div>
              <div class="desc-time">{{ article.created_at }}</div>
            </div>
          </div>
          <div class="article-content">
            <div v-html="article.content"></div>
          </div>
        </div>
        <div class="content-inner-right">
          <div class="news-box-item">
            <news-box type="news"></news-box>
          </div>
          <div class="news-box-item">
            <news-box type="qi"></news-box>
          </div>
        </div>
      </div>
    </div>
    <home-footer></home-footer>
  </div>
</template>
<script>
import homeTop from "@/components/public/home-top.vue";
import navicat from "@/components/navicat/navicat.vue";
import homeFooter from "@/components/public/home-footer.vue";
import newsBox from "@/components/goods/news-box.vue";
import { getNewsDetail } from "@/api/modules/home";
import { getSwiperList } from "@/api/modules/common";
export default {
  name: "news-detail",
  components: { homeTop, navicat, homeFooter, newsBox },
  data() {
    return {
      id: this.$route.query.id,
      article: {},
      loading: true,
      bannerList: [],
    };
  },

  created() {
    this.getNews(this.id);
    this.getBannert();
  },
  methods: {
    getBannert() {
      getSwiperList(2).then((res) => {
        this.bannerList = res.data.data;
      });
    },
    getNews(id) {
      getNewsDetail(id).then((res) => {
        this.article = res.data.data;
        this.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.h-top {
  // height: 157px;
  height: 120px;
}
.bannre-box {
  width: 100%;
  height: 400px;
  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover ;
  }
}

.content {
  .content-inner {
    display: flex;
    justify-content: space-between;
    padding-bottom: 200px;
    .content-inner-right {
      padding-top: 200px;
    }
    .content-inner-left {
      margin-right: 40px;
      .article-top {
        padding: 40px 0 20px;
        border-bottom: 1px solid #d1d5e3;
        .article-title {
          font-weight: bold;
          font-size: var(--font-size-default-big);
          color: #00112b;
          margin-bottom: 20px;
        }
        .article-desc {
          display: flex;
          .desc-tag {
            display: flex;
           align-items: center;
            .tag-author {
              font-weight: 400;
              font-size: var(--font-size-default-14);
              color: #00112b;
            }
            .tag {
              display: inline-block;
              height: 25px;
              background: #ffffff;
              border-radius: 15px 15px 15px 15px;
              border: 1px solid #afafaf;
              line-height: 25px;
              text-align: center;
              font-size: var(--font-size-default-14);
              color: #afafaf;
              padding: 0 10px;
            }
          }
          .desc-time {
            margin-left: 20px;
            line-height: 30px;
            font-weight: 400;
            font-size: var(--font-size-default-14);
            color: #00112b;
          }
        }
      }
    }
  }
}
</style>
